/**
 * Application Configuration
 * 
 * IMPORTANT: This file defines the backend API URL for the application.
 * 
 * Uses the current domain's origin so each deployment (hcp.exrsim.com, 
 * rac-acs.exrsim.com, etc.) uses its own backend automatically.
 */

// Get backend URL dynamically based on current domain
export const getBackendUrl = () => {
  // For local development on localhost, use localhost backend
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8001';
  }
  
  // For Emergent preview environments, use the env var (set at build time)
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.includes('.preview.emergentagent.com') && window.location.hostname.includes('.preview.emergentagent.com')) {
    return envUrl;
  }
  
  // For ALL deployed environments (hcp.exrsim.com, rac-acs.exrsim.com, etc.)
  // ALWAYS use the current domain origin. This ensures the frontend talks to
  // the same server it was loaded from, regardless of what REACT_APP_BACKEND_URL
  // was set to at build time.
  return window.location.origin;
};

// Export the backend URL
export const API_BASE_URL = getBackendUrl();

// Export API URL with /api suffix (for most endpoints)
export const API_URL = `${API_BASE_URL}/api`;

export default {
  API_BASE_URL,
  API_URL,
  BACKEND_URL: API_BASE_URL
};
